import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './index.module.less';
import HeadIcon from '@/components/HeadIcon';
import { timestampFormat } from '@/utils/format';
import classNames from 'classnames';
import Action from './Action';
import AttachFiles from './AttachFiles';
import ExpandInfo from './ExpandInfo';
import EmailChat from './EmailChat';
import { EmailUserIcon, AttachIcon } from '@/components/SvgIcon';
import { Skeleton } from 'antd';
import ReplyAI from '@/components/ReplyWithAI/index';
import { useConversationContext } from '../../../../context';
import { useTranslation } from 'react-i18next';
import { fetchAndParseEmail } from '@/components/ChatList/MailList/MailPreview/utils';
import MailRender from '@/components/Mailrender';
import { Loading } from '@/components/ChatList/MailList/MailPreview/icon';
import { formatSubjectPrefix, getDivider } from '../uitls';
const EmailMessage = (param)=>{
    let { data, isLast, isTiming, onRefresh } = param;
    var _Object_keys, _Object;
    const { conversationInfo, customerInfo } = useConversationContext();
    const { updateCustomerInfo } = useConversationContext();
    const { id } = useCoversationIds();
    const isScheduledTask = !!isTiming && ((_Object = Object) === null || _Object === void 0 ? void 0 : (_Object_keys = _Object.keys(isTiming)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.length) !== 0;
    const contentRef = useRef(null);
    const dispatch = useAppDispatch();
    const [clickReply, setClickReply] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [content, setContent] = useState('');
    const [isAiReply, setIsAiReply] = useState(0);
    const [loading, setLoading] = useState(false);
    const lastData = isLast(data.id);
    const aiReplyNo = (conversationInfo === null || conversationInfo === void 0 ? void 0 : conversationInfo.ai_replyable) == 1;
    const [notReplacedFileList, setNotReplacedFileList] = useState([]);
    const [toEmail, setToEmail] = useState('');
    const { t } = useTranslation();
    // S3邮件解析处理逻辑
    const fetchAndParseEmailContentFromS3 = async (url, attachments)=>{
        const res = await fetch(url);
        const text = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        // 去除GitHub邮件样式带来的污染
        doc.querySelectorAll('style').forEach((node)=>node.remove());
        doc.querySelectorAll('link').forEach((node)=>node.remove());
        let imageArr = [];
        // 替换图片src为cid开头的url为对应附件的cdn图片
        if (attachments === null || attachments === void 0 ? void 0 : attachments.length) {
            attachments.forEach((item)=>{
                // 解决多张图片重复使用同一个id的问题
                const imgNodes = doc.querySelectorAll(`img[src="cid:${item.id}"]`);
                if (imgNodes.length && item.url) {
                    imageArr.push(item);
                    imgNodes.forEach((it)=>it.setAttribute('src', item.url));
                }
            });
            // 替换过的图片不再重复渲染到邮件附件中
            const tempList = attachments === null || attachments === void 0 ? void 0 : attachments.map((item)=>{
                // 兼容历史数据没有id的文件
                if (!item.id) {
                    return {
                        ...item,
                        id: 'id-' + Date.now() + '-' + Math.floor(Math.random() * 10000)
                    };
                }
                return item;
            });
            const newList = tempList === null || tempList === void 0 ? void 0 : tempList.filter((item)=>!(imageArr === null || imageArr === void 0 ? void 0 : imageArr.includes(item)));
            setNotReplacedFileList(newList);
        }
        return doc.documentElement.outerHTML;
    };
    useEffect(()=>{
        const { attachments = [], body_html_url } = data ?? {};
        /** 默认展开最后一条邮件 */ if (lastData) {
            setIsCollapsed(true);
        } else if ((data === null || data === void 0 ? void 0 : data.expand) !== undefined) {
            /** 非最后一条，保持原来的折叠状态或根据data.expand */ setIsCollapsed(data.expand);
        }
        if (body_html_url) {
            setLoading(true);
            fetchAndParseEmail(body_html_url, attachments).then((value)=>{
                setContent(value.html);
                setNotReplacedFileList(value.attachments);
            }).finally(()=>setLoading(false));
        }
    }, [
        data,
        lastData
    ]);
    /** 邮件回复 */ const ReplyEmail = async (img)=>{
        const { subject, body_html_url } = data;
        const resolving_html = await fetchAndParseEmailContentFromS3(body_html_url);
        specialHandling(data);
        // @ts-ignore
        window['MAIL_REPLY_ID'] = data.id;
        dispatch(updateEditorContent({
            insertType: INSERT_TYPE.REPLY,
            subject: formatSubjectPrefix(subject, 'RE'),
            content: '',
            quote: `
        <blockquote>
        ${getDivider(data.from, new Date(data.sent_at), false)}
        <div style="border-left: 1px solid rgb(204, 204, 204); padding-left: .5em;">
          ${resolving_html}
        </div>
				 </blockquote>`,
            isAI: false,
            img: img
        }));
    };
    /** AI回复 */ const onAiReply = async (img)=>{
        var _conversationInfo_ai_reply_replace_replace_replace_replace, _conversationInfo_ai_reply_replace_replace_replace, _conversationInfo_ai_reply_replace_replace, _conversationInfo_ai_reply_replace, _conversationInfo_ai_reply;
        const { subject, body_html_url } = data;
        const resolving_html = await fetchAndParseEmailContentFromS3(body_html_url);
        specialHandling(data);
        // @ts-ignore
        window['MAIL_REPLY_ID'] = data.id;
        dispatch(updateEditorContent({
            insertType: INSERT_TYPE.REPLY,
            subject: formatSubjectPrefix(subject, 'RE'),
            content: '',
            quote: `
        <blockquote>
        ${getDivider(data.from, new Date(data.sent_at), false)}
        <div style="border-left: 1px solid rgb(204, 204, 204); padding-left: .5em;">
          ${resolving_html}
        </div>
				 </blockquote>`,
            aiReply: conversationInfo === null || conversationInfo === void 0 ? void 0 : (_conversationInfo_ai_reply = conversationInfo.ai_reply) === null || _conversationInfo_ai_reply === void 0 ? void 0 : (_conversationInfo_ai_reply_replace = _conversationInfo_ai_reply.replace('<', '&lt;')) === null || _conversationInfo_ai_reply_replace === void 0 ? void 0 : (_conversationInfo_ai_reply_replace_replace = _conversationInfo_ai_reply_replace.replace('>', '&gt;')) === null || _conversationInfo_ai_reply_replace_replace === void 0 ? void 0 : (_conversationInfo_ai_reply_replace_replace_replace = _conversationInfo_ai_reply_replace_replace.replace(/\\n/g, '\n')) === null || _conversationInfo_ai_reply_replace_replace_replace === void 0 ? void 0 : (_conversationInfo_ai_reply_replace_replace_replace_replace = _conversationInfo_ai_reply_replace_replace_replace.replace(/\/n/g, '\n')) === null || _conversationInfo_ai_reply_replace_replace_replace_replace === void 0 ? void 0 : _conversationInfo_ai_reply_replace_replace_replace_replace.replace(/\n/g, '<p/>'),
            isAI: true,
            img: img
        }));
    };
    /** 邮件转发 */ const forwardEmail = async (img)=>{
        const { from, sent_at, subject, to, body_html_url } = data;
        const resolving_html = await fetchAndParseEmailContentFromS3(body_html_url);
        // 转发邮件不需要收起展开, 替换掉所有blockquote标签
        const new_html = resolving_html === null || resolving_html === void 0 ? void 0 : resolving_html.replace(/<\/?blockquote>/g, '');
        // @ts-ignore
        window['MAIL_REPLY_ID'] = data.id;
        dispatch(updateEditorContent({
            insertType: INSERT_TYPE.REPLY,
            subject: formatSubjectPrefix(subject, 'FWD'),
            content: `${getDivider(from, new Date(sent_at), true, subject, to)}`,
            quote: `${new_html}`,
            isAI: false,
            img: img,
            isRelay: true,
            imgList: notReplacedFileList
        }));
    };
    /** 特殊回复处理 */ const specialHandling = (data)=>{
        let formItemNode = document.querySelectorAll('.form-section');
        let obj = Object.fromEntries([
            ...formItemNode
        ].map((item)=>{
            const key = item.children[0].innerText.slice(0, -1).toLowerCase();
            const value = item.children[1].innerText;
            return [
                key,
                value
            ];
        }));
        const customer_email = customerInfo.email;
        const email = (data === null || data === void 0 ? void 0 : data.reply_to) || (conversationInfo === null || conversationInfo === void 0 ? void 0 : conversationInfo.real_customer_address) || customer_email;
        if (Object.keys(obj).length === 0) {
            updateCustomerInfo((info)=>{
                if (!info) {
                    return info;
                }
                return {
                    ...info,
                    real_email: email,
                    real_name: obj.name,
                    status: false
                };
            });
        }
    };
    const toggleCollapse = ()=>{
        // if (lastData) return
        setIsCollapsed(!isCollapsed);
        if (!isCollapsed) setClickReply(false);
    };
    const handleEvent = ()=>{
        setClickReply(false);
        if (isAiReply == 1) {
            setIsAiReply(0);
        }
    // onRefresh?.()
    };
    // 滚动最底部
    const scrollToBottom = (data)=>{
        let timer = setTimeout(()=>{
            const element = document.querySelector(`[data-id="${data.id}"]`);
            element === null || element === void 0 ? void 0 : element.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest'
            });
            clearTimeout(timer);
        }, 1000);
    };
    useEffect(()=>{
        if (aiReplyNo && !!content) {
            const email = conversationInfo.real_customer_address || customerInfo.email;
            setToEmail(email);
        }
    }, [
        aiReplyNo,
        content
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles['email-message'], {
            [styles['no-data-line']]: lastData
        }),
        "data-type": data.type,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between cursor-pointer items-center",
                onClick: toggleCollapse,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex",
                        style: {
                            flex: '0.9'
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: data.type == 1 || data.type == 5 ? /*#__PURE__*/ _jsx(HeadIcon, {
                                    name: data.name,
                                    id: id,
                                    email: true,
                                    selectDisabled: true
                                }) : /*#__PURE__*/ _jsx("div", {
                                    className: styles['you-email'],
                                    children: t('p1_d_you')
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "ml-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "font-medium text-[#262626] text-[14px] flex",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mr-[16px]",
                                                children: data === null || data === void 0 ? void 0 : data.name
                                            }),
                                            data.operator && /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "flex",
                                                        children: EmailUserIcon
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "text-[12px] font-normal",
                                                        children: data === null || data === void 0 ? void 0 : data.operator
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isCollapsed && /*#__PURE__*/ _jsx("div", {
                                        className: classNames('font-normal text-[#7E7E7E] text-[14px]', styles['expand-header-text']),
                                        children: data === null || data === void 0 ? void 0 : data.body_text
                                    }),
                                    isCollapsed && /*#__PURE__*/ _jsx(ExpandInfo, {
                                        info: data
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex",
                        children: [
                            (notReplacedFileList === null || notReplacedFileList === void 0 ? void 0 : notReplacedFileList.length) > 0 && /*#__PURE__*/ _jsx("div", {
                                className: "text-[#7E7E7E] flex text-[12px] mr-[6px] relative top-[1px]",
                                children: AttachIcon
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles['time-line'],
                                children: timestampFormat(data.sent_at, false)
                            }),
                            isCollapsed && /*#__PURE__*/ _jsx("div", {
                                className: styles.action,
                                children: isAiReply == 0 ? /*#__PURE__*/ _jsx(Action, {
                                    source: data.type !== 1 ? 1 : 0,
                                    // @ts-ignore
                                    onReply: async (event)=>{
                                        event.stopPropagation();
                                        setIsAiReply(1);
                                        ReplyEmail();
                                        setTimeout(()=>{
                                            setClickReply(true);
                                        }, 100);
                                        scrollToBottom(data);
                                    // onRefresh?.()
                                    },
                                    // @ts-ignore
                                    onForward: async (event)=>{
                                        event.stopPropagation();
                                        setIsAiReply(1);
                                        forwardEmail();
                                        setTimeout(()=>{
                                            setClickReply(true);
                                        }, 100);
                                        scrollToBottom(data);
                                    }
                                }) : null
                            })
                        ]
                    })
                ]
            }),
            isCollapsed ? /*#__PURE__*/ _jsx("div", {
                className: styles.wrap,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.content,
                    ref: contentRef,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: classNames(styles.email, styles.active),
                            children: loading ? /*#__PURE__*/ _jsx(Skeleton, {
                                paragraph: {
                                    rows: 8
                                }
                            }) : content ? /*#__PURE__*/ _jsx(MailRender, {
                                htmlContent: content
                            }) : /*#__PURE__*/ _jsxs("div", {
                                className: classNames('text-[16px] flex items-center py-[20px]'),
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: classNames('mr-[4px] flex items-center justify-center'),
                                        children: Loading
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        children: t('p1_e_mail_downloading')
                                    })
                                ]
                            })
                        }),
                        (notReplacedFileList === null || notReplacedFileList === void 0 ? void 0 : notReplacedFileList.length) > 0 && /*#__PURE__*/ _jsx("div", {
                            className: classNames(styles['attach-files']),
                            children: /*#__PURE__*/ _jsx(AttachFiles, {
                                files: notReplacedFileList
                            })
                        })
                    ]
                })
            }) : null,
            clickReply && isCollapsed && /*#__PURE__*/ _jsx(EmailChat, {
                onEvent: handleEvent,
                id: data.id,
                onRefresh: onRefresh,
                isScheduledTask: isScheduledTask
            }),
            lastData && aiReplyNo && isAiReply === 0 && /*#__PURE__*/ _jsx(ReplyAI, {
                message: conversationInfo === null || conversationInfo === void 0 ? void 0 : conversationInfo.ai_reply,
                email: toEmail,
                onAIReply: async ()=>{
                    setIsAiReply(1);
                    onAiReply();
                    setTimeout(()=>{
                        setClickReply(true);
                    }, 200);
                    scrollToBottom(data);
                }
            })
        ]
    });
};
export default EmailMessage;
